module.exports = __webpack_public_path__ + "static/media/icon_email-notify.48970be6.svg";